import React from "react";
import Logo from "./Logo";
import heroImage from "../images/piccola_rossa.jpg";
import img1 from "../images/piccola_tav.jpg";
import img3 from "../images/piccola_tav_2.jpg";
import img2 from "../images/console_night.jpg";

export default function LaPiccola() {
  return (
    <div className="bg-white text-black">
      <Logo />

      {/* Main content area with consistent margin */}
      <div className="m-[100px]">
        {/* Hero Section */}
        <div className="relative w-full h-[60vh]">
          <img
            src={img1}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0  bg-opacity-40 flex items-center justify-center">
            <h1 className="text-white text-5xl font-extrabold">LA PICCOLA</h1>
          </div>
        </div>
        <br></br>
        <div className="relative w-full h-[100vh]">
          <img
            src={heroImage}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Concept Section */}
        <section className="flex flex-col md:flex-row items-center gap-2 mt-16">
          <img
            src={img2}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />
          {/* </section> */}
          {/* <section className="flex flex-col md:flex-row items-center gap-8 mt-16"> */}
          <img
            src={img3}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />
        </section>
      </div>
    </div>
  );
}
